import { Navigate, Outlet, useLocation } from "react-router-dom";
import * as routesPaths from "@constants/routes";


// 1. Porteiro da Manutenção
export const MaintenanceGuard = ({ isMaintenance }) => {
  const manutMode = isMaintenance === true || isMaintenance === 'true';
  if (manutMode) return <Navigate to={routesPaths.R_MANUT} replace />;
  return <Outlet />; 
};

// 2. Porteiro de Usuários Logados (Privado)
export const ProtectedGuard = ({ isAuthenticated }) => {
  const location = useLocation(); 

  if (!isAuthenticated) {
    return (
      <Navigate 
        to={routesPaths.R_LOGIN} 
        replace 
        state={{ from: location }} 
      />
    );
  }
  return <Outlet />; 
};

// 3. Porteiro de Usuários Deslogados (Público/Login)
export const GuestGuard = ({ isAuthenticated }) => {
  const location = useLocation();

  if (isAuthenticated) {
    // Se o usuário logou e veio redirecionado de outra página, manda ele de volta para lá.
    // Se não houver histórico, manda para a Dashboard padrão.
    const destination = location.state?.from?.pathname || routesPaths.R_DASHBOARD;
    return <Navigate to={destination} replace />;
  }
  return <Outlet />;
};